(function ($) {
  const behavior = 'polyu_theme.views-ar-scholarship';
  var ug_filter_count = 0;
  Drupal.behaviors[behavior] = {
    attach: (context, settings) => {
      once(behavior, '.container--view--ar-scholarship .views-exposed-form').forEach(pattern => {
        ar_scholarship_show_count_filter(pattern);
        ar_scholarship_wrap_second_filter(pattern);
        ar_scholarship_show_filter_button(pattern);
      })
    },

  };
  $(function () {
  });

  function ar_scholarship_show_filter_button(pattern) {
    const form = $(pattern);
    const show_filter_button = form.find('.show_filter');
    const second_filter = form.find('.second_filter');
    const hide_filter = "Hide Filters <i class=\"fa-light fa-angle-up\"></i>";
    const show_filter = "Show Filters <span class='filter-count'>" + ug_filter_count + "</span><i class=\"fa-light fa-angle-down\"></i>";

    if (second_filter != "undefined") {
      if (second_filter.css("display") !== 'none') {
        show_filter_button.html(hide_filter);
      } else {
        show_filter_button.html(show_filter);
      }
    }
  }

  function ar_scholarship_show_count_filter(pattern) {
    const form = $(pattern);
    const fieldset = form.find('.fieldset');
    ug_filter_count = 0;
    fieldset.find('input[type=checkbox]').each(function () {
      if ($(this).is(':checked')) {
        ug_filter_count++;
      }
    });
  }

  function ar_scholarship_wrap_second_filter(pattern) {
    const form = $(pattern);
    if (form.find('.first_filter').length == 0) {
      form.children().wrapAll("<div class='second_filter'><div class='container'></div></div>");
      form.prepend("<div class='first_filter'><div class='form_title'>List of Scholarships</div></div>")
      form.find('.first_filter').append('<div class="show_filter ug">Show Filters <span class="filter-count">' + ug_filter_count + '</span><i class="fa-light fa-angle-down"></i></div>')
    }

    form.find('.show_filter').on('click', function (e) {
      form.find('.second_filter').slideToggle(500, 'linear', function () {
        ar_scholarship_show_filter_button(pattern);
      });

    });
  }
})(jQuery);
